import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { AngularSvgIconModule } from "angular-svg-icon";

@Component({
  selector: "app-star-line-item",
  templateUrl: "./star-line-item.component.html",
  styleUrls: ["./star-line-item.component.scss"],
  standalone: true,
  imports: [CommonModule, AngularSvgIconModule],
})
export class StarLineItemComponent {
  @Input() name: string = "";
  @Output() clicked = new EventEmitter<void>();
}
